/* global bocAmchart, AmCharts */

/**
 * @typedef {{bocSettings: {series, ga, addExport, lookup}, listeners, export}} AMConfig
 */

/**
 * Get the list of series and labels from the shortcode and add all the graphs to the chart
 * Automatically makes the first two series into a band
 * Also sets the valet_url based on the series list
 *
 * @param {array} fromShortcode Array of parameters taken from the shortcode
 * @param {AMConfig} chartSettings Object The settings to be used to build this chart
 * @return {void}
 */
bocAmchart.setSeriesFromShortcodeWithRange = function (fromShortcode, chartSettings) {
    var series = [];
    var i = 0;
    var hasMoreData = true;
    var valueSuffix = '';

    if (typeof bocAmchart.vars === 'object'
        && typeof bocAmchart.vars[chartSettings.bocSettings.id] === 'object'
        && typeof bocAmchart.vars[chartSettings.bocSettings.id]['valueSuffix'] === 'string') {
        valueSuffix = bocAmchart.vars[chartSettings.bocSettings.id]['valueSuffix'];
    }

    while (hasMoreData) {
        if (fromShortcode.hasOwnProperty('series' + i)) {
            var thisLabel = '';
            var thisSeries = fromShortcode['series' + i];
            series.push(thisSeries);
            if (fromShortcode.hasOwnProperty('series' + i + 'label')) {
                thisLabel = fromShortcode['series' + i + 'label'];
            }
            switch (i) {
                case 0:
                    chartSettings.graphs.push(
                        {
                            "id": "lower",
                            "lineAlpha": 0,
                            "showBalloon": false,
                            "valueField": thisSeries,
                            "fillAlphas": 0,
                            "title": thisLabel,
                            "lineColor": "#cccccc"
                        }
                    );
                    break;
                case 1:
                    chartSettings.graphs.push(
                        {
                            "id": "upper",
                            "fillAlphas": 0.2,
                            "fillToGraph": "lower",
                            "lineAlpha": 0,
                            "showBalloon": false,
                            "valueField": thisSeries,
                            "visibleInLegend": false,
                            "lineColor": "#cccccc"
                        }
                    );
                    break;
                default:
                    chartSettings.graphs.push(
                        {
                            "id": "g" + i,
                            "lineThickness": 1,
                            "title": thisLabel,
                            "useLineColorForBulletBorder": true,
                            "valueField": thisSeries,
                            "balloonText": "<span style='font-size: 14px;'>[[value]]" + valueSuffix + " [[" + thisSeries + "_R]]- " + thisLabel + "</span>",
                            "lineColor": AmCharts.themes[chartSettings.bocSettings.theme].AmCoordinateChart.colors[i - 2]
                        }
                    );
            }
        } else {
            hasMoreData = false;
        }
        i++;
    }

    bocAmchart.setValetDataLoader(fromShortcode, chartSettings, series);
};

/**
 * Get the list of series and labels from the shortcode and add all the graphs to the chart
 * Also sets the valet_url based on the series list
 *
 * @param {array} fromShortcode Array of parameters taken from the shortcode
 * @param {AMConfig} chartSettings Object The settings to be used to build this chart
 * @param {boolean} skipGraphs optional parameter, if set to true, graphs are not intialized, just series and datasource
 * @return {void}
 */
bocAmchart.setSeriesFromShortcode = function (fromShortcode, chartSettings, skipGraphs) {
    var series = [];
    var i = 0;
    var hasMoreData = true;

    // Back up the defined graphs for possible overrides
    var graphsFromJs = chartSettings.graphs;
    chartSettings.graphs = [];

    while (hasMoreData) {
        if (fromShortcode.hasOwnProperty('series' + i)) {
            var thisSeries = fromShortcode['series' + i];

            series.push(thisSeries);

            if (skipGraphs !== true) {
                bocAmchart.addGraph(chartSettings, thisSeries);
            }

            // Check if chart config had per graph settings to apply
            if (Array.isArray(graphsFromJs)) {
                if (bocAmchart.debug(chartSettings)) {
                    // eslint-disable-next-line no-console
                    console.log(
                        chartSettings.bocSettings.id,
                        "Applying overrides for graph g" + i + " from chart post:",
                        bocAmchart.debugClone(graphsFromJs)
                    );
                }
                graphsFromJs.forEach(function (perGraphOverride) {
                    if (perGraphOverride.hasOwnProperty("id") && perGraphOverride.id === ("g" + i)) {
                        for (var graphProp in perGraphOverride) {
                            if (graphProp !== "id" && perGraphOverride.hasOwnProperty(graphProp)) {
                                chartSettings.graphs[i][graphProp] = perGraphOverride[graphProp];
                            }
                        }
                    }
                });
            }

        } else {
            hasMoreData = false;
        }
        i++;
    }

    if (bocAmchart.debug(chartSettings)) {
        // eslint-disable-next-line no-console
        console.log(
            chartSettings.bocSettings.id,
            "Actually added graphs:",
            bocAmchart.debugClone(chartSettings.graphs),
            "Chart after series were processed:",
            bocAmchart.debugClone(chartSettings)
        );
    }

    bocAmchart.setValetDataLoader(fromShortcode, chartSettings, series);

    if (bocAmchart.debug(chartSettings)) {
        // eslint-disable-next-line no-console
        console.log(
            "Chart after valet data loader is set inside series from shortcode function:",
            bocAmchart.debugClone(chartSettings)
        );
    }
};

/**
 * Hide any charts that come after keepVisible graphs.
 * 2 means keep two charts visible, hide the rest.
 *
 * @param {AMConfig} chartSettings Object The settings to be used to build this chart
 * @param {int} keepVisible number of graphs to not hide
 * @return {void}
 */
bocAmchart.hideGraphs = function (chartSettings, keepVisible) {
    if (Array.isArray(chartSettings.graphs)) {
        for (var i = keepVisible; i < chartSettings.graphs.length; i++) {
            chartSettings.graphs[i].hidden = true;
        }
    }
};

/**
 * Hook to a drawn event the function to show/hide the upper limit graphs
 * @param {AMConfig} chartSettings Object The settings to be used to build this chart
 * @return {void}
 */
bocAmchart.hideBandOnLegendClick = function (chartSettings) {
    chartSettings.listeners.push({
        "event": "drawn",
        "method": bocAmchart.chartWithBandDrawn
    });
};

/**
 * Function to run on hideItem and showItem events for the banded chart
 * @param {object} event The AMChart drawn event
 * @return {void}
 */
bocAmchart.copyHigerLimitStateFromLower = function (event) {
    if (event.dataItem.id === 'lower') {
        switch (event.type) {
            case 'hideItem':
                event.chart.hideGraph(event.chart.graphs[1]);
                break;
            case 'showItem':
                event.chart.showGraph(event.chart.graphs[1]);
                break;
        }
    }
};

/**
 * Function to run on drawn event for the banded chart
 * @param {object} event The AMChart drawn event
 * @return {void}
 */
bocAmchart.chartWithBandDrawn = function (event) {
    event.chart.legend.addListener("hideItem", bocAmchart.copyHigerLimitStateFromLower);
    event.chart.legend.addListener("showItem", bocAmchart.copyHigerLimitStateFromLower);
};

